export default __webpack_public_path__ + "static/media/FamilyNumber12.50cc5859.svg";